
import React from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
    faTriangleExclamation
} from '@fortawesome/free-solid-svg-icons';

const Alert = () =>{
    return(
        <div className="container mt-6">
            <div className="card">
                <div className="card-header">
                    <h3>Alert</h3>
                </div>
                <div className="card-body">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="alert alert-primary alert-dismissible fade show" role="alert">
                                <strong>Hi alert!</strong> You should check in on some of those fields below.
                                <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                            </div>
                            <div className="alert alert-danger alert-dismissible fade show" role="alert">
                                <strong>Hi alert!</strong> You should check in on some of those fields below.
                                <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                            </div>
                            <div className="alert alert-success alert-dismissible fade show" role="alert">
                                <strong>Hi alert!</strong> You should check in on some of those fields below.
                                <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                            </div>
                            <div className="alert alert-primary alert-dismissible fade show" role="alert">
                                <FontAwesomeIcon icon={faTriangleExclamation} className="mr-10" />
                                <div className="d-inline">
                                    An example alert with an icon
                                </div>
                                <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="alert alert-info" role="alert">
                                <h4 className="alert-heading">Well done!</h4>
                                <p>Aww yeah, you successfully read this important alert message. This example text is going to run a bit longer so that you can see how spacing within an alert works with this kind of content.</p>
                                <p className="mb-0">Whenever you need to, be sure to use margin utilities to keep things nice and tidy.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Alert;